import React from 'react';
import PropTypes from 'prop-types';

import PriceSliderFilter from './PriceSliderFilter';
import DatePickerFilter from './DatePickerFilter';

const BaseFilters = props => {
  const classNameToUse = props.simpleFilters ? 'search-simple-filters' : '';

  return (
    <div className={classNameToUse}>
      <DatePickerFilter
        from={props.filters['move-in']}
        flexibleMoveIn={props.filters.flexibleMoveIn}
        flexibleMoveOut={props.filters.flexibleMoveOut}
        minimumStaying={props.minimumStaying}
        to={props.filters['move-out']}
        updateFiltersWith={props.updateFiltersWith}
      />
      <PriceSliderFilter
        budget={props.filters.budget}
        currency={props.currency}
        maxPriceInCity={props.maxPriceInCity}
        unitPrices={props.unitPrices}
        updateFiltersWith={props.updateFiltersWith}
      />
    </div>
  );
};

BaseFilters.propTypes = {
  simpleFilters: PropTypes.bool.isRequired,
  filters: PropTypes.object.isRequired,
  updateFiltersWith: PropTypes.func.isRequired,
  currency: PropTypes.object.isRequired,
  unitPrices: PropTypes.array.isRequired,
  maxPriceInCity: PropTypes.number.isRequired,
  minimumStaying: PropTypes.number.isRequired
};

export default BaseFilters;
